/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Path_OpenInputs */

const en_tut_path_open = /** @type {(inputs: Tut_Path_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open this path`)
};

const id_tut_path_open = /** @type {(inputs: Tut_Path_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka jalur ini`)
};

/**
* | output |
* | --- |
* | "Open this path" |
*
* @param {Tut_Path_OpenInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_path_open = /** @type {((inputs?: Tut_Path_OpenInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Path_OpenInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_path_open(inputs)
	return en_tut_path_open(inputs)
});